import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface PanelSectionProps {
  title?: string;
  trailing?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

/** Card used for every block inside the ticket inspector tabs. */
export function PanelSection({
  title,
  trailing,
  children,
  className,
  bodyClassName,
}: PanelSectionProps) {
  const hasHeader = Boolean(title || trailing);

  return (
    <section
      className={cn(
        'rounded-xl border border-white/[0.06] bg-white/[0.02]',
        className,
      )}
    >
      {hasHeader && (
        <header className="flex items-center justify-between gap-3 px-4 pb-2 pt-3">
          {title && (
            <h3 className="text-[13px] font-semibold tracking-wide text-white/90">
              {title}
            </h3>
          )}
          {trailing}
        </header>
      )}
      <div className={cn('px-4 pb-4', !hasHeader && 'pt-4', bodyClassName)}>
        {children}
      </div>
    </section>
  );
}
